<template>
  <div id="app">
    <title>Chart data extraction</title>
    <b-container>
      <b-row align-v="center" align-h="between">
        <b-col cols="11"> </b-col>
        <b-col cols="1" class="language">
          <!-- <div class="language-btn"> -->

          <b-button
            class="language-btn"
            v-on:click="set_lang('en')"
            :disabled="language == 'en'"
          >
            <img src="./assets/flag_en.svg" />
            <!-- </div> -->
          </b-button>

          <b-button
            class="language-btn"
            v-on:click="set_lang('de')"
            :disabled="language == 'de'"
          >
            <img src="./assets/flag_de.svg" />
            <!-- </div> -->
          </b-button>
          <!-- <div class="language-btn">
            <img
              v-on:click="set_lang('de')"
              src="./assets/flag_de.svg"
              :disabled="language == 'de'"
            />
          </div> -->
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="between">
        <div style="text-align: right">
          <a href="https://www.tib.eu/en/">
            <img
              alt="TIB logo"
              height="112"
              src="./assets/logo.svg"
              class="tiblogo"
            />
          </a>
        </div>
        <div>
          <h1>Figure2Text</h1>
          <h2>Chart Data Extraction</h2>
        </div>
        
        <div style="text-align: left">
          <a href="https://www.l3s.de/de/projects/inclusiveocw">
          <img
            alt="iOCW logo"
            src="./assets/IOCW_Web.png"
            height="112"
            class="tiblogo"
          />
        </div>
      </b-row>

      <b-row align-v="center">
        <b-col>
          <b-row>
            <b-col>
              <div style="margin-top: 20px; font-weight: 600">
                {{ $t("change_image") }}
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div class="image-container" style="max-width: 100%" v-if="show_text_editor == false">
                <img
                  class="image-full"
                  v-bind:src="image_url"
                  height="300px"
                  alt="Responsive image"
                  style="cursor: pointer"
                  
                />
                <div class="overlay">
                  <div class="overlay-upload" v-on:click="upload_image">
                    <i class="fa fa-upload"></i>
                  </div>
                  <div class="overlay-paste">
                    <input
                      type="text"
                      class="image-paste"
                      :placeholder="$t('paste_image')"
                      v-model="pasted_image_url"
                      @keypress="fetch_image"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-button v-on:click="get_json_description">{{
        $t("extract_data")
      }}</b-button>
      <b-row>
        <b-col>
          <div
            class="text-center tib_red spinner-container"
            style="height: 30px"
          >
            <b-spinner
              id="loading-spinner"
              type="grow"
              ref="loading-spinner"
              label="Loading..."
              v-bind:style="spinner_disabled ? 'display:none' : ''"
            >
            </b-spinner>
          </div>

          <div
            class="html-description"
            v-html="html_desc"
            v-if="spinner_disabled"
          ></div>
        </b-col>
      </b-row>

      <b-row style="margin-top: 20px;">
        <b-col>
          <b-button
            id="btn-get-desc"
            class="tib-btn"
            v-if="show_change_values"
            v-on:click="toggle_editor"
            >{{ $t("change_text") }}
          </b-button>
        </b-col>
        <b-col>
          <b-button
            id="btn-get-desc"
            class="tib-btn"
            v-if="show_change_values"
            v-on:click="copy_description"
            >{{ $t("copy_html") }}
          </b-button>
        </b-col>
      </b-row>

      <div
        id="modify_text"
        ref="modify_text"
        class="modal_popup flex"
        v-if="show_text_editor"
      >
        <template v-if="this.json_desc.type == 'pie'">
            <b-row class="change-container">
              <b-col class="change-meta-col">
                <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="title-input">{{ $t("change_title") }}</label>
                  
                    <input
                      id="title-input"
                      class="change-input"
                      ref="change-input"
                      v-model="json_desc.title"
                    >
                    </div>
                </b-row>
                <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="num-input">{{ $t("change_num") }}</label>
                    <input
                      id="num-input"
                      class="change-input"
                      ref="change-input"
                      type="number"
                      min="1"
                      v-model.number="json_desc.numElements"
                      @input="insert_element()"
                    >
                  </div>
                </b-row>
              </b-col>
              <b-col class="overlay-image-col">
                <div class="image-container-overlay" style="max-width: 100%">
                  <canvas id="canvas" class="canvas-bbox"></canvas>
                  <img
                    class="image-full"
                    v-bind:src="image_url"
                    height="300px"
                    v-if="show_text_editor"
                  />
                </div>
            </b-col>
              <b-col class="change-lv-col">
                <div class="scrollable">
                  <b-row class="label-value-row" :key="index" v-for="(n,index) in json_desc.numElements">
                    <div>
                      <label class="change-value-label" for="label-input">{{ $t("change_label") }}</label>
                      <input
                        id="label-input"
                        class="change-input"
                        ref="change-input"
                        v-model="json_desc.graph[index].label"
                      >
                    </div>
                
                  <div>
                    <label class="change-value-label" for="value-input">{{ $t("change_value") }}</label>
                    <input
                      id="value-input"
                      class="change-input"
                      ref="change-input"
                      type="number"
                      v-model.number="json_desc.graph[index].relative_value"
                    >
                  </div>
                </b-row>
                </div>
            </b-col>
          </b-row>
        </template>

        <template v-else>
            <b-row class="change-container">
              <b-col class="change-meta-col">
                <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="title-input">{{ $t("change_title") }}</label>
                  
                    <input
                      id="title-input"
                      class="change-input"
                      ref="change-input"
                      v-model="json_desc.title"
                    >
                    </div>
                </b-row>
                <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="num-input">{{ $t("change_num") }}</label>
                    <input
                      id="num-input"
                      class="change-input"
                      ref="change-input"
                      type="number"
                      min="1"
                      v-model.number="json_desc.numElements"
                      @input="insert_element()"
                    >
                  </div>
                </b-row>
                 <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="x-axis-input">{{ $t("change_x") }}</label>
                  
                    <input
                      id="x-axis-input"
                      class="change-input"
                      ref="change-input"
                      v-model="json_desc.xAxisLabel"
                    >
                    </div>
                </b-row>
                <b-row class="change-meta-row">
                  <div>
                    <label class="change-value-label" for="y-axis-input">{{ $t("change_y") }}</label>
                  
                    <input
                      id="y-axis-input"
                      class="change-input"
                      ref="change-input"
                      v-model="json_desc.yAxisLabel"
                    >
                    </div>
                </b-row>              
                </b-col>

                <b-col class="overlay-image-col">
                <div class="image-container-overlay" style="max-width: 100%">
                  <canvas id="canvas" class="canvas-bbox"></canvas>
                  <img
                    class="image-full"
                    v-bind:src="image_url"
                    height="300px"
                    v-if="show_text_editor"
                  />
                </div>
                  
              </b-col>

              <b-col class="change-lv-col">
                <div class="scrollable">
                <b-row class="label-value-row" :key="index" v-for="(n,index) in json_desc.numElements">
                  <div>
                    <label class="change-value-label" for="label-input">{{ $t("change_label") }}</label>
                    <input
                      id="label-input"
                      class="change-input"
                      ref="change-input"
                      v-model="json_desc.graph[index].label"
                      @click="draw_bbox(index)"
                    >
                  </div>

                  <div>
                    <label class="change-value-label" for="value-input">{{ $t("change_value") }}</label>
                    <input
                      id="value-input"
                      class="change-input"
                      ref="change-input"
                      type="number"
                      v-model.number="json_desc.graph[index].absolute_value"
                    >
                  </div>
                </b-row>
                </div>
            </b-col>
          </b-row>
        </template>

          <b-row class="modify-btn">
            <div>
                <b-row class="btn-row">
                  <b-button
                    id="btn-modify-text"
                    class="tib-btn"
                    v-on:click="get_html_description"
                    >{{ $t("update_text") }}
                  </b-button>
                </b-row>
                <b-row class="btn-row">
                  <b-button
                    id="btn-reset-desc"
                    variant="danger"
                    class="tib-btn red"
                    v-on:click="reset_desc"
                    >{{ $t("reset_json") }}
                  </b-button>
                </b-row>
              </div>
          </b-row>

      </div>
    </b-container>
  </div>
</template>

<script>
//var URL_BACKEND = "http://localhost:5000";
var URL_BACKEND = "/fig2text/gunicorn";
var URL_MEDIA = "/fig2text/media";
//var URL_MEDIA = "http://127.0.0.1:5000/";

import axios from "axios";
import i18n from "./i18n";
// import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
// import InnerImageZoom from 'vue-inner-image-zoom';

export default {
  name: "App",
  components: {
    // 'inner-image-zoom': InnerImageZoom
  },
  data() {
    return {
      url_media: URL_MEDIA,

      pasted_image_url: null,

      html_desc: this.$t("tutorial"),
      json_desc: "",
      restore_json: "",
      image_url:
        "https://www.jennybeaumont.com/wp-content/uploads/2015/03/placeholder.gif",
      image_id: "",
      processing_status: "",
      spinner_disabled: true,
      btn_disabled: false,
      show_text_editor: false,
      show_change_values: false,
      job_id: null,
      polling_job: null,

      language: "en",
    };
  },
  methods: {
    draw_bbox(index) {
      const canvas = document.querySelector("#canvas");
      const ctx = canvas.getContext("2d");

      let [ow, oh] = this.json_desc.shape;
      console.log("Shape", ow, oh);
      let [bx, by, bw, bh] = this.json_desc.graph[index].bbox;
      console.log("Bbox", bx, by, bw, bh);
      let ch = canvas.height;
      let cw = canvas.width;
      console.log("Canvas size", ch, cw);

      let h = (bh / oh) * ch;
      let w = (bw / ow) * cw;
      let x = (bx / ow) * cw;
      let y = (by / oh) * ch;
      console.log("Paint", x, y, w, h);

      ctx.clearRect(0, 0, cw, ch);
      ctx.beginPath();
      ctx.rect(x, y, w, h);
      ctx.strokeStyle = "red";
      ctx.stroke();
    },
    insert_element() {
      if (
        this.json_desc.numElements < 0 ||
        isNaN(this.json_desc.numElements) ||
        typeof this.json_desc.numElements === "string"
      ) {
        console.log("No valid input");
        this.json_desc.numElements = this.json_desc.graph.length;
        return;
      }
      if (this.json_desc.numElements > this.json_desc.graph.length) {
        let amount = this.json_desc.numElements - this.json_desc.graph.length;
        for (let i = 0; i < amount; i++) {
          this.json_desc.graph.push({
            label: "",
            color: "",
            absolute_value: 0,
            relative_value: 0,
          });
        }
      }
      if (this.json_desc.numElements < this.json_desc.graph.length) {
        let amount = this.json_desc.graph.length - this.json_desc.numElements;
        for (let i = 0; i < amount; i++) {
          this.json_desc.graph.pop();
        }
      }
    },
    set_lang(lang) {
      this.language = lang;
      i18n.locale = lang;
      this.$on();
      if (this.json_desc) {
        this.get_html_description();
      } else {
        this.html_desc = this.$t("tutorial", lang);
      }
    },
    reset_desc() {
      this.json_desc = JSON.parse(JSON.stringify(this.restore_json));
      console.log("Reset json");
    },
    fetch_image(e) {
      const URL = URL_BACKEND + "/fetch_image/";
      if (e.key === "Enter") {
        console.log("fetch image");
        axios.post(URL, { url: this.pasted_image_url }).then((response) => {
          this.pasted_image_url = null;
          console.log(response);
          console.log(response.data["status"]);
          if (response.data["status"] == "success") {
            console.log(response.data["fname"]);
            this.image_id = response.data["image_id"];
            this.image_url =
              URL_MEDIA + "/" + response.data["image_id"] + ".jpg";
          }
          if (response.data["status"] == "error") {
            this.processing_status = this.$t("fetch_image_error");
          }
        });
      }
    },
    upload_image() {
      const URL = URL_BACKEND + "/upload_image/";
      this.btn_disabled = true;
      console.log("Calling " + URL);
      var input = document.createElement("input");
      input.type = "file";

      input.onchange = (event) => {
        let data = new FormData();
        data.append("file", event.target.files[0]);

        let config = {
          header: { "Content-Type": "image/png" },
        };

        axios.post(URL, data, config).then((response) => {
          console.log(response);
          console.log(response.data["status"]);
          if (response.data["status"] == "success") {
            console.log(response.data["fname"]);
            this.image_id = response.data["image_id"];
            this.image_url =
              URL_MEDIA + "/" + response.data["image_id"] + ".jpg";
          }
          this.btn_disabled = false;
        });
      };
      input.click();
    },
    toggle_editor() {
      this.show_text_editor = !this.show_text_editor;
      document.documentElement.style.overflow = "auto";
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    get_json_description() {
      // get job_id description for currently uploaded/selected image
      if (this.image_id == "") {
        return;
      }
      let image_URL = URL_BACKEND + "/imagejob/" + this.image_id;
      this.spinner_disabled = false;
      this.show_change_values = false;

      axios
        .get(image_URL)
        .then((response) => {
          var job_id = response.data["job_id"];
          console.log("job received:" + job_id);
          this.poll_job(job_id, 2000, 8000);
        })
        .catch((error) => {
          this.html_desc = "<h2>Error, could not reach server.</h2>";
          console.log(error);
          this.spinner_disabled = true;
        });
    },
    poll_job(job_id, interval, timeout) {
      let job_URL = URL_BACKEND + "/get_description/" + job_id;
      interval = interval || 100;
      var endTime = Number(new Date()) + (timeout || 2000);
      console.log("Start polling");
      (function p() {
        console.log("Poll");
        axios
          .get(job_URL)
          .then((response) => {
            var app = document.querySelector("#app").__vue__;
            app.json_desc = response.data.description;
            if (app.json_desc.type.endsWith("bar")) {
              app.json_desc.graph = app.json_desc.graph.sort(
                (a, b) => a.bbox[0] - b.bbox[0]
              );
            }
            app.restore_json = JSON.parse(JSON.stringify(app.json_desc));
            console.log("Received", typeof app.json_desc, app.json_desc);
            app.get_html_description();
            console.log("Finished!");
          })
          .catch((error) => {
            if (Number(new Date()) < endTime) {
              setTimeout(p, interval);
            } else {
              var app = document.querySelector("#app").__vue__;
              app.html_desc = "<h2>Error, no chart found.</h2>";
              console.log(error);
              app.spinner_disabled = true;
            }
          });
      })();
    },
    get_html_description() {
      console.log("Getting html");
      this.spinner_disabled = false;
      this.show_text_editor = false;
      let url_ = URL_BACKEND + "/convertHTML/";

      let config = {
        header: { "Content-Type": "application/json;charset=utf-8" },
      };

      let data = {
        lang: this.language,
      };

      if (typeof this.json_desc === "string") {
        data["description"] = JSON.parse(this.json_desc);
      } else {
        data["description"] = this.json_desc;
      }

      console.log(
        "HTML - desc before call",
        typeof this.json_desc,
        this.json_desc
      );

      axios
        .post(url_, data, config)
        .then((response) => {
          this.html_desc = response.data["description"];
          if (typeof this.json_desc !== "object") {
            this.json_desc = JSON.parse(this.json_desc);
          }
          this.show_change_values = true;
          this.spinner_disabled = true;
        })
        .catch((error) => {
          this.html_desc = "<h2>Error, unable to get HTML description.</h2>";
          console.log(error);
          this.spinner_disabled = true;
        });
    },
    async copy_description() {
      var app = document.querySelector("#app").__vue__;
      if (!window.isSecureContext) {
        console.log("Cannot copy in unsecured context, use https.");
      }
      await navigator.clipboard.writeText(app.html_desc);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #555555;
  font-size: 16px;
}
.modify-btn {
  justify-content: center;
  align-items: center;
  display: flex;
}
.btn-row {
  align-self: center;
  display: flex;
}
a {
  color: #313131;
}
a:hover {
  color: #313131;
}
.canvas-bbox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  /* background-color: rgba(255,0,0,.1); */
}

.above-overlay {
  z-index: 100;
  position: relative;
}
.change-meta-row {
  margin-right: 5%;
  justify-content: right;
  display: flex;
  margin-top: 5%;
}
.scrollable {
  overflow-y: auto;
  overflow-x: hidden;
  height: 70vh;
  position: absolute;
  width: 80%;
}
.label-value-row {
  margin-left: 5%;
  display: flex;
  justify-content: left;
  padding: 20px;
}

.change-container {
  margin-top: 5%;
}
.change-value-label {
  color: #f8f8f8;
  font-size: 22px;
  font-weight: 600;
  text-align: left;
  display: block;
  margin-left: 15px;
}
h1 {
  font-size: 36px;
  font-weight: 600;
  /* text-align: left; */
  /* padding-left: 1rem; */
}
h2 {
  font-size: 22px;
  font-weight: 600;
  text-align: left;
}
.left {
  text-align: left;
}
.logo {
  height: 112px;
  max-width: 100%;
}
.language {
  display: flex;
  /* background-color: rgba(0, 0, 0, 0.137);
  border-radius: 16px 0 16px 0;

  border-color: rgba(0, 0, 0, 1);  */

  margin-bottom: 10px;
}
.language-btn.btn {
  border-radius: 0 0 3px 3px;
  margin-top: 0;
  margin-left: 1px;
  margin-right: 1px;
  padding: 5px;
  /* margin-left: 1px;
  margin-right: 1px;
  padding-left: 1px;
  padding-top: 1px;

  cursor: pointer; */
}

.language-btn img {
  height: 15px;
  width: 30px;
  object-fit: cover;
}
/* 
.language-btn img:disabled {
  opacity: 0.3;
}

.language-btn img:hover:not(:disabled) {
  opacity: 0.6;
} */
.spinner-container {
  /* background-color: rgba(0, 0, 0, 0.25); */
  font-weight: 600;
  font-size: 20px;
  color: rgba(175, 20, 20, 1);
  margin-top: 30px;
  align-content: center;
}
#loading-spinner {
  color: rgba(175, 20, 20, 1);
}
.red {
  background-color: #af1414;
}
.btn {
  margin: 10px;
  padding: 10px;
  background-color: #ededed;
  color: #555;
  width: 200px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  border-radius: 0 16px 0 16px;
  /* border-radius: 32px; */
  transition: 0.4s;
  border-color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 600;
}
.btn:hover {
  border-radius: 16px 0 16px 0;
}
.btn-narrow {
  width: 25%;
}
.btn-wide {
  width: 100%;
}
.btn-tib {
  background-color: rgba(175, 20, 20, 1);
  color: #fff;
}

.image-container {
  width: 100%;
  height: 256px;
}

.overlay-image-col {
  height: 60vh;
}
.image-container-overlay {
  width: 100%;
  /* height: 256px; */
  align-content: bottom;
  position: absolute;
  height: 60vh;
}
.image-full {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-container .overlay {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 10;
  cursor: pointer;
  opacity: 0;
}

.image-container .overlay-upload {
  width: 100%;
  height: 70%;
  display: flex;
}

.image-container .overlay-paste {
  width: 100%;
  height: 30%;
  display: flex;
}

.image-container .overlay-paste input {
  margin: auto;
  width: 70%;

  display: block;
  padding: 5px;
  color: #313131;
  font-size: 12px;
  appearance: none;
  border: none;
  outline: none;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 0 8px 0 8px;
  transition: 0.4s;
}

.image-container .overlay-paste input:focus {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 8px 0 8px 0;
}

.image-container .overlay:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.431);
}

.image-container .overlay-upload i {
  margin: auto;
  font-size: 70px;
}
.html-description * {
  text-align: center;
}

.html-description h1,
h2,
h3 {
  color: #af1414;
}
.html-description table {
  margin-top: 10px;
  justify-content: center;
  display: flex;
}
.html-description td {
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  border: solid 3px;
}
.textbox {
  min-height: 200px;
  line-height: 2.5;
  padding: 10px;
  text-align: left;
  background-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
}
.modal_popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99;
}
.change-input {
  color: #3a3a3a;
  text-align: center;
  border-radius: 30px;
  border: 0px;
  /* padding: 20px; */
  padding-left: 15px;
  padding-right: 15px;
  background-color: rgba(255, 255, 255);
  box-shadow: 0 0 8px rgba(158, 94, 94, 0.25);
  margin-left: 15px;
  resize: none !important;
}
.texteditor:focus {
  outline: none;
}
</style>


<i18n>
{
  "en": {
    "change_image":"You can click on the image to change it",
    "extract_data" : "Extract data",
    "change_text":"Adjust values",
    "update_text":"Update description",
    "reset_json" : "Reset data",
    "copy_html":"Copy HTML", 
    "paste_image": "Paste the URL to an image and hit enter",
    "tutorial":  "(1) Upload a chart by pasting its URL or clicking on the image above. (2) A description will be generated based on the automatically extracted chart data. (3) You can adjust the extracted values by clicking on the \"Change values\" button. (4) The Button \"Copy Description\" copies the HTML description to the clipboard ",
    "fetch_image_error": "Image not found or too large",
    "change_label" : "Label",
    "change_value" : "Value",
    "change_y" : "Y-Axis Label",
    "change_x" : "X-Axis Label",
    "change_title" : "Title",
    "change_num" : "Elements"
  },
  "de": {
    "change_image":"Klicken Sie auf das Bild um es zu ändern",
    "extract_data" : "Daten extrahieren",
    "change_text":"Werte anpassen",
    "update_text":"Beschreibung aktualisieren",
    "reset_json" : "Daten zurücksetzen",
    "copy_html":"HTML kopieren",
    "paste_image": "Fügen Sie den Weblink eines Bildes ein und drücken sie die Enter-Taste ...",
    "tutorial":  "1. Laden Sie ein Diagramm hoch indem Sie entweder den Weblink des Bildes einfügen oder das Bild (durch einen Klick auf das Bild) direkt hochladen. 2. Die extrahierten Daten werden benutzt um eine Bildbeschreibung zu erstellen. 3. Sie können eventuell fehlerhaft erkannte Werte und Label über den Button \"Werte anpassen\" ändern. Die erstellte HTML Beschreibung kann über den Button \"Beschreibung kopieren\" direkt in die Zwischenablage kopiert werden",
    "fetch_image_error": "Bild nicht gefunden oder zu groß",
    "change_label" : "Label",
    "change_value" : "Wert",
    "change_x" : "X-Achsenabschnitt",
    "change_y" : "Y-Achsenabschnitt",
    "change_title" : "Titel",
    "change_num" : "Elemente"
  }
}
</i18n>